<div [ngStyle]="{ height: height + 'px' }">
  <div class="flex flex-column justify-content-between overflow-y-hidden h-full">
    <div
      *ngFor="let rowNumber of rows | enumerate : true; let i = index"
      class="flex gap-2"
    >
      <div style="width: 10%">
        <p-skeleton [height]="((height / rows) - gap) + 'px'"></p-skeleton>
      </div>
      <div style="width: 30%">
        <p-skeleton [height]="((height / rows) - gap) + 'px'"></p-skeleton>
      </div>
      <div style="width: 60%">
        <p-skeleton [height]="((height / rows) - gap) + 'px'"></p-skeleton>
      </div>
    </div>
  </div>
</div>
